import { CHECKOUT_REDESIGN_FEATURE_FLAG } from '@/constants/experimentConstants';
import { useGetAmplitudeExperimentVariant } from '../useAmplitudeExperiment';

type CheckoutVariant = 'control' | 'v1' | 'v2';

const useCheckoutExperiment = (): {
  variant: CheckoutVariant;
} => {
  const fetchFlagVariant = useGetAmplitudeExperimentVariant();

  function getVariant(): CheckoutVariant {
    const variant = fetchFlagVariant(CHECKOUT_REDESIGN_FEATURE_FLAG);

    if (variant?.value === 'v1') {
      return 'v1';
    }

    if (variant?.value === 'v2') {
      return 'v2';
    }

    return 'control';
  }

  return {
    variant: getVariant(),
  };
};

export default useCheckoutExperiment;
